export const CanvasPromptTextarea = {
  extends: 'PromptTextarea',
  pointerEvents: 'auto',
  state: { size: 'small', images: [] },
  position: 'absolute',
  bottom: 'X2',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 10,
  theme: 'canvas-card-glass',
  minHeight: 'auto',
  boxSize: 'auto',
  overflow: 'hidden',
  transition: 'B all defaultBezier',

  width: (el, s) => ({ small: 'H', normal: 'H2', large: 'I' })[s.size],
  height: (el, s) => (s.size === 'large' ? '75dvh' : 'auto'),
  maxHeight: (el, s) =>
    s.size === 'large' ? '75dvh' : s.size === 'normal' ? '35dvh' : 'auto',

  isSmall: (el, s) => s.size === 'small',
  '.isSmall': {
    flow: 'x',
    align: 'center start',
    gap: '0',
    padding: '0',
    minHeight: '0',
    boxSize: 'auto'
  },

  PromptGallery: {
    show: (el, s) => (s.images || []).length > 0 && s.size !== 'small',
    gap: 'Z',
    margin: '0',
    childProps: {
      boxSize: 'D'
    }
  },

  Textarea: {
    minWidth: (el, s) => (s.size === 'small' ? 'auto' : '100%'),
    resize: 'none',
    height: (el, s) => (s.size === 'small' ? 'auto' : '100%'),
    overflow: (el, s) => (s.size === 'small' ? 'hidden' : 'auto'),
    transition: 'B all defaultBezier',
    minHeight: (el, s) => {
      if (s.size === 'small') return 'auto'
      return s.size === 'large' ? '75dvh' : 'E'
    },
    maxHeight: (el, s) => {
      if (s.size === 'small') return '35dvh'
      return s.size === 'large' ? '75dvh' : '35dvh'
    },
    paddingTop: (el, s) => (s.size === 'small' ? 'Y' : 'A'),
    paddingBottom: (el, s) => (s.size === 'small' ? 'Y' : 'C'),
    paddingLeft: (el, s) => (s.size === 'small' ? 'A' : 'A'),
    paddingRight: (el, s) => (s.size === 'small' ? 'A' : 'A2'),
    fontSize: (el, s) => (s.size === 'small' ? 'Z2' : 'A'),
    flexGrow: (el, s) => (s.size === 'small' ? '1' : undefined),

    onRender: (el) => {
      if (el.__taInit) return
      el.__taInit = true
      el.node.rows = 1
    },

    onInput: (e, el, s) => {
      if (s.size === 'small') {
        el.node.style.height = 'auto'
        el.node.style.height =
          Math.min(el.node.scrollHeight, window.innerHeight * 0.35) + 'px'
        return
      }
      const maxH = s.size === 'normal' ? 0.35 : 0.65
      el.node.style.minHeight = ''
      const scrollH = el.node.scrollHeight
      const cap = window.innerHeight * maxH
      if (scrollH > el.node.clientHeight) {
        el.node.style.minHeight = Math.min(scrollH, cap) + 'px'
      }
    },
    onPaste: (e, el, s) => {
      const items = e.clipboardData?.items
      if (!items) return
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          e.preventDefault()
          const blob = items[i].getAsFile()
          if (!blob) continue
          const reader = new FileReader()
          reader.onloadend = () => {
            const images = [...(s.images || []), reader.result]
            s.update({ images })
          }
          reader.readAsDataURL(blob)
        }
      }
    }
  },

  PromptButtons: {
    flow: 'x',
    align: 'center start',
    gap: (el, s) => (s.size === 'small' ? 'X' : 'Z'),
    fontSize: 'Z1',
    transition: 'B all defaultBezier',
    childExtends: 'NavbarButton',
    childProps: {
      padding: (el, s) => (s.size === 'small' ? 'Y' : 'Y2'),
      transition: 'B all defaultBezier'
    },

    position: (el, s) => (s.size === 'small' ? 'static' : 'absolute'),
    bottom: (el, s) => (s.size === 'small' ? 'auto' : 'Z'),
    left: (el, s) => (s.size === 'small' ? 'auto' : 'A'),
    right: (el, s) => (s.size === 'small' ? 'auto' : 'C2'),
    marginRight: (el, s) => (s.size === 'small' ? 'X' : undefined),
    flexShrink: '0',

    InspectBtn: {
      icon: 'sf cursor',
      title: 'Inspect mode',
      onClick: (ev, el) => {
        el.setCanvasMode('inspectMode')
      }
    },
    UploadBtn: {
      // `extends: 'UploadThreadImageIcon'` pointed at a non-existent
      // component → the button rendered with no icon and the wrong
      // box-model. NavbarButton (inherited via PromptButtons.childExtends)
      // already gives us the toolbar style; we just add an upload icon
      // and a hidden file input layered on top of the button surface.
      tag: 'label',
      icon: 'uploadOutline',
      title: 'Upload image',
      position: 'relative',
      cursor: 'pointer',
      Input: {
        tag: 'input',
        type: 'file',
        accept: 'image/*',
        position: 'absolute',
        inset: '0',
        opacity: '0',
        cursor: 'pointer',
        onChange: (e, el, s) => {
          const file = e.target.files[0]
          if (!file || !file.type.startsWith('image/')) return
          const reader = new FileReader()
          reader.onloadend = () => {
            const root = s.parent?.parent || s
            const images = [...(root.images || []), reader.result]
            root.update({ images })
            el.node.value = ''
          }
          reader.readAsDataURL(file)
        }
      }
    },
    ExpandBtn: {
      icon: 'arrowAngleUp',
      show: (el, s) => s.size === 'small',
      onClick: (e, el, s) => {
        s.update({ size: 'normal' })
      }
    }
  },

  Flex: null,
  Button: null,

  ExpandCornerBtn: {
    extends: 'NavbarButton',
    if: (el, s) => s.size !== 'small',
    icon: (el, s) =>
      s.size === 'large'
        ? 'arrowAngleDiagonalRight'
        : 'arrowAngleDiagonalLeft',
    position: 'absolute',
    top: 'Z',
    right: 'Z',
    padding: 'Y2',
    fontSize: 'Z1',
    opacity: '.5',
    ':hover': { opacity: '1' },
    onClick: (e, el, s) => {
      if (s.size === 'normal') s.update({ size: 'large' })
      else s.update({ size: 'normal' })
    }
  },

  MinimizeBtn: {
    extends: 'NavbarButton',
    if: (el, s) => s.size !== 'small',
    icon: 'arrowAngleDown',
    position: 'absolute',
    bottom: 'Z',
    right: 'D',
    padding: 'Y2',
    fontSize: 'Z1',
    onClick: (e, el, s) => {
      s.update({ size: 'small' })
    }
  },

  CircleButton: {
    position: (el, s) => (s.size === 'small' ? 'relative' : 'absolute'),
    bottom: (el, s) => (s.size === 'small' ? 'auto' : 'Z'),
    right: (el, s) => (s.size === 'small' ? 'auto' : 'Z'),
    marginRight: (el, s) => (s.size === 'small' ? 'X' : undefined),
    flexShrink: '0',
    icon: 'chevronUp',
    padding: (el, s) => (s.size === 'small' ? 'Y' : 'Z'),
    theme: 'canvas-card-glass-reversed',
    Icon: {
      transform: 'rotate(45deg)'
    }
  }
}
